// Tides – Secondary Ports exercises (Innisfail, Cooktown, Abel Point)
// Extracted from live WordPress block attributes (allships.com.au), tidesSecondaryPorts
const tidesSecondaryPorts = [
  {
    tabGroup: "exercises_secondary",
    tideform_published: true,
    tideform_description: "Calculate the height of tide for secondary port Innisfail (Mourilyan Harbour) on 4th of February 2025. ",
    tideform_tab_title: "Exercise 1 - Innisfail",
    tideform_show_secondary_port: true,
    tideform_std_row1_time: "01:32",
    tideform_std_row1_height: "2.20",
    tideform_std_row2_time: "07:07",
    tideform_std_row2_height: "1.66",
    tideform_std_row3_time: "13:20",
    tideform_std_row3_height: "2.36",
    tideform_std_row4_time: "20:49",
    tideform_std_row4_height: "1.33",
    tideform_sec_row1_timediff: "+0:25",
    tideform_sec_row1_ratio: "0.98",
    tideform_sec_row1_constant: "-0.63",
    tideform_sec_row2_timediff: "+0:55",
    tideform_sec_row2_ratio: "0.98",
    tideform_sec_row2_constant: "-0.63",
    tideform_sec_table2_row1_time: "01:57",
    tideform_sec_table2_row1_height: "1.53",
    tideform_sec_table2_row2_time: "08:02",
    tideform_sec_table2_row2_height: "1.00",
    tideform_sec_table2_row3_time: "13:45",
    tideform_sec_table2_row3_height: "1.68",
    tideform_sec_table2_row4_time: "21:44",
    tideform_sec_table2_row4_height: "0.67",
    tideform_show_tidal_range: false,
    tideform_show_vessel_requirements: false,
    tideform_show_low_water: false,
    tideform_show_required_tide: false,
    tideform_std_row1_tide: "HW",
    tideform_std_row2_tide: "LW",
    tideform_std_row3_tide: "HW",
    tideform_std_row4_tide: "LW",
    tideform_sec_row1_tide: "HW",
    tideform_sec_row2_tide: "LW",
    tideform_sec_table2_row1_tide: "HW",
    tideform_sec_table2_row2_tide: "LW",
    tideform_sec_table2_row3_tide: "HW",
    tideform_sec_table2_row4_tide: "LW",
    tideform_range_hw: "",
    tideform_range_lw: "",
    tideform_range_range: "",
    tideform_vessel_ukc: "",
    tideform_vessel_draught: "",
    tideform_vessel_total: "",
    tideform_vessel_charteddepth: "",
    tideform_vessel_requiredheight: "",
    tideform_lowwater_chartlat: "",
    tideform_lowwater_lw: "",
    tideform_lowwater_total: "",
    tideform_required_total: "",
    tideform_required_actuallw: "",
    tideform_required_tideheight: "",
    tideform_required_tidetime: "",
    tideform_show_tide_result: false,
    tideform_show_tide_time: false,
    tideform_tide_time_extrawater: "",
    tideform_tide_time_earliest: "",
    tideform_tide_result_tidetime: "",
    tideform_tide_result_timediff: "",
    tideform_tide_result_extra_height: "",
    tideform_tide_result_height: "",
  },
  {
    tabGroup: "exercises_secondary",
    tideform_published: true,
    tideform_description: "Calculate the height of tide for secondary port Cooktown (Cairns) on 16th of April 2025. \n\nAlso calculate the Tidal range for the secondary port at 18:05",
    tideform_tab_title: "Exercise 2 - Cooktown",
    tideform_show_secondary_port: true,
    tideform_show_tidal_range: true,
    tideform_std_row1_tide: "LW",
    tideform_std_row1_time: "04:24",
    tideform_std_row1_height: "1.66",
    tideform_std_row2_tide: "HW",
    tideform_std_row2_time: "09:39",
    tideform_std_row2_height: "2.12",
    tideform_std_row3_tide: "LW",
    tideform_std_row3_time: "16:12",
    tideform_std_row3_height: "1.08",
    tideform_std_row4_tide: "HW",
    tideform_std_row4_time: "22:55",
    tideform_std_row4_height: "2.46",
    tideform_sec_row1_timediff: "-0:02",
    tideform_sec_row1_ratio: "0.92",
    tideform_sec_row1_constant: "0.00",
    tideform_sec_row2_timediff: "+0:06",
    tideform_sec_table2_row1_tide: "LW",
    tideform_sec_table2_row1_time: "04:30",
    tideform_sec_table2_row1_height: "1.53",
    tideform_sec_table2_row2_tide: "HW",
    tideform_sec_table2_row2_time: "09:37",
    tideform_sec_table2_row2_height: "1.95",
    tideform_sec_table2_row3_tide: "LW",
    tideform_sec_table2_row3_time: "16:18",
    tideform_sec_table2_row3_height: "0.99",
    tideform_sec_table2_row4_tide: "HW",
    tideform_sec_table2_row4_time: "22:53",
    tideform_sec_table2_row4_height: "2.26",
    tideform_range_hw: "2.26",
    tideform_range_lw: "0.99",
    tideform_range_range: "1.27",
    tideform_show_vessel_requirements: false,
    tideform_show_low_water: false,
    tideform_show_required_tide: false,
    tideform_sec_row1_tide: "HW",
    tideform_sec_row2_tide: "LW",
    tideform_sec_row2_ratio: "",
    tideform_sec_row2_constant: "",
    tideform_vessel_ukc: "",
    tideform_vessel_draught: "",
    tideform_vessel_total: "",
    tideform_vessel_charteddepth: "",
    tideform_vessel_requiredheight: "",
    tideform_lowwater_chartlat: "",
    tideform_lowwater_lw: "",
    tideform_lowwater_total: "",
    tideform_required_total: "",
    tideform_required_actuallw: "",
    tideform_required_tideheight: "",
    tideform_required_tidetime: "",
    tideform_show_tide_result: false,
    tideform_show_tide_time: false,
    tideform_tide_time_extrawater: "",
    tideform_tide_time_earliest: "",
    tideform_tide_result_tidetime: "",
    tideform_tide_result_timediff: "",
    tideform_tide_result_extra_height: "",
    tideform_tide_result_height: "",
  },
  {
    tabGroup: "exercises_secondary",
    tideform_published: true,
    tideform_description: "Calculate the height of tide for secondary port Abel Point (Shute Harbour) on 14th of October 2025. \n\nYou arrive at the secondary port at 07:35\n\nUsing the tidal curve, interpolate the extra water after low water and calculate tide height at arrival time.",
    tideform_tab_title: "Exercise 3 - Abel Point",
    tideform_show_secondary_port: true,
    tideform_show_tidal_range: true,
    tideform_std_row1_time: "05:37",
    tideform_std_row1_height: "2.32",
    tideform_std_row2_time: "11:15",
    tideform_std_row2_height: "0.97",
    tideform_std_row3_time: "17:59",
    tideform_std_row3_height: "3.48",
    tideform_std_row4_tide: "",
    tideform_sec_row1_timediff: "-0:07",
    tideform_sec_row1_ratio: "0.91",
    tideform_sec_row1_constant: "0.00",
    tideform_sec_row2_timediff: "-0:06",
    tideform_sec_table2_row1_time: "05:30",
    tideform_sec_table2_row1_height: "2.11",
    tideform_sec_table2_row2_time: "11:09",
    tideform_sec_table2_row2_height: "0.88",
    tideform_sec_table2_row3_time: "17:52",
    tideform_sec_table2_row3_height: "3.17",
    tideform_sec_table2_row4_tide: "",
    tideform_range_hw: "2.11",
    tideform_range_lw: "0.88",
    tideform_range_range: "1.23",
    tideform_show_tide_result: true,
    tideform_tide_result_tidetime: "07:35",
    tideform_tide_result_timediff: "+02:05",
    tideform_tide_result_extra_height: "0.75",
    tideform_tide_result_height: "1.63",
    tideform_show_vessel_requirements: false,
    tideform_show_low_water: false,
    tideform_show_required_tide: false,
    tideform_std_row1_tide: "HW",
    tideform_std_row2_tide: "LW",
    tideform_std_row3_tide: "HW",
    tideform_std_row4_time: "",
    tideform_std_row4_height: "",
    tideform_sec_row1_tide: "HW",
    tideform_sec_row2_tide: "LW",
    tideform_sec_row2_ratio: "",
    tideform_sec_row2_constant: "",
    tideform_sec_table2_row1_tide: "HW",
    tideform_sec_table2_row2_tide: "LW",
    tideform_sec_table2_row3_tide: "HW",
    tideform_sec_table2_row4_time: "",
    tideform_sec_table2_row4_height: "",
    tideform_vessel_ukc: "",
    tideform_vessel_draught: "",
    tideform_vessel_total: "",
    tideform_vessel_charteddepth: "",
    tideform_vessel_requiredheight: "",
    tideform_lowwater_chartlat: "",
    tideform_lowwater_lw: "",
    tideform_lowwater_total: "",
    tideform_required_total: "",
    tideform_required_actuallw: "",
    tideform_required_tideheight: "",
    tideform_required_tidetime: "",
    tideform_show_tide_time: false,
    tideform_tide_time_extrawater: "",
    tideform_tide_time_earliest: "",
  },
];

export default tidesSecondaryPorts;
